import React from 'react';
export function RotateClockwise({
  height = 24,
  width = 24
}: {
  height?: number;
  width?: number;
}) {
  return <svg width={`${height}px`} height={`${width}px`} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <g id="Layer_2" data-name="Layer 2">
        <g id="invisible_box" data-name="invisible box">
          <rect width="48" height="48" fill="none" />
        </g>
        <g id="icons_Q2" data-name="icons Q2">
          <g>
            <path d="M42.3,2A2,2,0,0,0,40,4V8.9A22,22,0,0,0,2,24H2a2,2,0,0,0,4,0H6A18,18,0,0,1,37.4,12H32.1A2.1,2.1,0,0,0,30,13.7,2,2,0,0,0,32,16H42a2,2,0,0,0,2-2V4.1A2.1,2.1,0,0,0,42.3,2Z" />
            <path d="M24,42h0a2,2,0,1,0,2,2A2,2,0,0,0,24,42Z" />
            <path d="M15,39.6h0a1.9,1.9,0,0,0-2.7.7A1.9,1.9,0,0,0,13,43a2,2,0,0,0,2-3.4Z" />
            <path d="M8.4,33a1.9,1.9,0,0,0-2.7-.7A2,2,0,0,0,4.9,35a2.1,2.1,0,0,0,2.8.7A1.9,1.9,0,0,0,8.4,33Z" />
            <path d="M42.3,32.3a1.9,1.9,0,0,0-2.7.7h0a1.9,1.9,0,0,0,.7,2.7A1.9,1.9,0,0,0,43,35,1.9,1.9,0,0,0,42.3,32.3Z" />
            <path d="M33,39.6h0a1.9,1.9,0,0,0-.7,2.7,2,2,0,0,0,2.7.8,2.1,2.1,0,0,0,.7-2.8A1.9,1.9,0,0,0,33,39.6Z" />
          </g>
        </g>
      </g>
    </svg>;
}